// src/pages/PartnerSignup.jsx
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

const PartnerSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConnectStripe = async () => {
    setLoading(true);
    setError('');
    try {
      const functions = getFunctions(getApp());
      const createConnectAccount = httpsCallable(functions, 'createConnectAccount');
      
      // Call the backend function
      const result = await createConnectAccount();
      
      // 🚀 THIS IS THE LOGIC THAT WAS MISSING 🚀
      // Instead of just showing the data, we force the browser to go to the URL.
      if (result.data && result.data.url) {
        window.location.href = result.data.url; 
      } else {
        setError("Received response but no URL found.");
      }

    } catch (err) {
      console.error("Stripe Connect Error:", err);
      setError("Failed to connect with Stripe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Become a Partner</h1>
        <p className="text-gray-600 mb-8">
          Earn 10% commission on every referral. We use Stripe to ensure you get paid securely and on time.
        </p>

        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        <button 
          onClick={handleConnectStripe} 
          disabled={loading}
          className="w-full bg-[#635BFF] hover:bg-[#534bef] text-white font-bold py-3 px-6 rounded-lg transition duration-200 flex items-center justify-center"
        >
          {loading ? 'Connecting...' : 'Connect with Stripe'}
        </button>
        
        <p className="text-xs text-gray-400 mt-4">
          You will be redirected to Stripe's secure onboarding page.
        </p>
      </div>
    </div>
  );
};

export default PartnerSignup;